
import { defineComponent } from "vue";

import {
  ColumnDefinition,
  OptionType,
  BaseButton,
  DeleteIcon,
  SouthIcon,
  NorthIcon,
  BaseTable,
  FormField,
} from "@tager/admin-ui";

import { moveItem } from "@/views/BasisProductForm/BasisProductForm.helpers";
import CategoryTable from "@/views/CategoryForm/components/ThroughNavigationTable/CategoryTable.vue";

const COLUMN_DEFS: Array<ColumnDefinition> = [
  {
    id: 1,
    name: "Название",
    field: "name",
    style: { width: "200px" },
    headStyle: { width: "200px" },
  },
  {
    id: 2,
    name: "Категории",
    field: "categories",
  },
  {
    id: 3,
    name: "",
    field: "actions",
    style: { width: "140px", textAlign: "center", whiteSpace: "nowrap" },
    headStyle: { width: "140px", textAlign: "center" },
  },
];

type Props = Readonly<{
  cross: Array<{
    name: string;
    items: Array<{ category: OptionType<number> }>;
  }>;
}>;

export default defineComponent({
  name: "ThroughNavigationTable",
  components: {
    CategoryTable,
    BaseButton,
    DeleteIcon,
    SouthIcon,
    NorthIcon,
    BaseTable,
    FormField,
  },
  props: {
    cross: {
      type: Array,
      required: true,
    },
    categoryOptionList: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    function removeField(rowIndex: number) {
      props.cross.splice(rowIndex, 1);
    }

    function handleClick(
      itemList: Array<{ name: string; items: Array<OptionType<number>> }>,
      itemIndex: number,
      direction: "up" | "down"
    ) {
      moveItem<{ name: string; items: Array<OptionType<number>> }>(
        itemList,
        itemIndex,
        direction
      );
    }

    function addElement(
      cross: Array<{ name: string; items: Array<OptionType<number>> }>
    ) {
      cross.push({
        name: "",
        items: [],
      });
    }

    return {
      columnDefs: COLUMN_DEFS,
      removeField,
      handleClick,
      addElement,
    };
  },
});
